import angular from 'angular';

import Component from './foot-note.component';

const FootNote = angular
    .module('control-room.commons.layout.components.foot-note', [])
    .component('crFootNote', Component);

export default FootNote;
